[
  {
    "enhet": "volvo-penta-evc",
    "signal": "motor.varvtal",
    "omrakning": "Varvtalet i 127488, i varv per minut"
  },
  { "enhet": "volvo-penta-evc", "signal": "motor.kylvatten_temp", "omrakning": null },
  { "enhet": "volvo-penta-evc", "signal": "motor.oljetryck", "omrakning": null },
  { "enhet": "volvo-penta-evc", "signal": "motor.timmar", "omrakning": null },
  { "enhet": "volvo-penta-evc", "signal": "motor.bransle", "omrakning": null },
  { "enhet": "volvo-penta-evc", "signal": "motor.laddning", "omrakning": null },
  { "enhet": "volvo-penta-evc", "signal": "motor.last", "omrakning": null },
  { "enhet": "volvo-penta-evc", "signal": "motor.status", "omrakning": null },
  {
    "enhet": "volvo-penta-evc",
    "signal": "motor.tripp_liter",
    "omrakning": "Volvos resedata i 127497"
  },
  {
    "enhet": "volvo-penta-evc",
    "signal": "tripp.nm_till_tom",
    "omrakning": "Volvos resedata i 127496"
  },
  {
    "enhet": "motor-nmea2000",
    "signal": "motor.varvtal",
    "omrakning": "Varvtalet i 127488, i varv per minut"
  },
  { "enhet": "motor-nmea2000", "signal": "motor.kylvatten_temp", "omrakning": null },
  { "enhet": "motor-nmea2000", "signal": "motor.oljetryck", "omrakning": null },
  { "enhet": "motor-nmea2000", "signal": "motor.timmar", "omrakning": null },
  { "enhet": "motor-nmea2000", "signal": "motor.bransle", "omrakning": null },
  { "enhet": "motor-nmea2000", "signal": "motor.laddning", "omrakning": null },
  { "enhet": "motor-nmea2000", "signal": "motor.last", "omrakning": null },
  { "enhet": "motor-nmea2000", "signal": "motor.status", "omrakning": null },
  {
    "enhet": "tankgivare-nmea2000",
    "signal": "tank.niva",
    "omrakning": "Nivån i 127505; tankens namn i signalerna är sorten och numret, till exempel diesel2"
  },
  { "enhet": "tankgivare-nmea2000", "signal": "tank.kapacitet", "omrakning": "Capacity i 127505" },
  {
    "enhet": "raymarine-evolution",
    "signal": "autopilot.lage",
    "omrakning": "Läget i 127237 och i Raymarines egna PGN 65379"
  },
  { "enhet": "raymarine-evolution", "signal": "autopilot.kurs", "omrakning": null },
  { "enhet": "autopilot-nmea2000", "signal": "autopilot.lage", "omrakning": "Läget i 127237" },
  { "enhet": "autopilot-nmea2000", "signal": "autopilot.kurs", "omrakning": null },
  { "enhet": "gps-nmea2000", "signal": "position", "omrakning": null },
  {
    "enhet": "gps-nmea2000",
    "signal": "instrument.fart_kn",
    "omrakning": "Farten över grund i m/s, räknad om till knop"
  },
  {
    "enhet": "gps-nmea2000",
    "signal": "instrument.kurs_grader",
    "omrakning": "Kursen i radianer, räknad om till grader"
  },
  {
    "enhet": "kurs-nmea2000",
    "signal": "bat.kurs",
    "omrakning": "Radianer, räknade om till grader"
  },
  { "enhet": "kurs-nmea2000", "signal": "bat.girhastighet", "omrakning": null },
  { "enhet": "kurs-nmea2000", "signal": "bat.trim", "omrakning": null },
  { "enhet": "kurs-nmea2000", "signal": "bat.slagsida", "omrakning": null },
  { "enhet": "mastervolt-mli", "signal": "batteri.soc", "omrakning": null },
  { "enhet": "mastervolt-mli", "signal": "batteri.spanning", "omrakning": null },
  { "enhet": "mastervolt-mli", "signal": "batteri.strom", "omrakning": null },
  { "enhet": "mastervolt-mli", "signal": "batteri.temp", "omrakning": null },
  { "enhet": "mastervolt-mass-combi", "signal": "landstrom.finns", "omrakning": null },
  { "enhet": "mastervolt-mass-combi", "signal": "landstrom.spanning", "omrakning": null },
  { "enhet": "mastervolt-mass-combi", "signal": "laddare.lage", "omrakning": null },
  { "enhet": "mastervolt-mass-combi", "signal": "laddare.strom", "omrakning": null },
  { "enhet": "mastervolt-mass-combi", "signal": "vaxelriktare.pa", "omrakning": null },
  {
    "enhet": "mastervolt-mass-combi",
    "signal": "generator.gar",
    "omrakning": "Generatoringången (tab 0, index 95): går när spänningen är över 100 V"
  },
  { "enhet": "mastervolt-chargemaster", "signal": "laddare.lage", "omrakning": null },
  { "enhet": "mastervolt-chargemaster", "signal": "laddare.strom", "omrakning": null },
  { "enhet": "mastervolt-mac-plus", "signal": "laddare.lage", "omrakning": null },
  {
    "enhet": "ecowitt-ha",
    "signal": "ute.temp",
    "omrakning": "Entitetens enhet räknas om till SI, till exempel °F till °C"
  },
  { "enhet": "ecowitt-ha", "signal": "ute.fukt", "omrakning": null },
  {
    "enhet": "ecowitt-ha",
    "signal": "vader.vind",
    "omrakning": "km/h, mph och knop räknas om till m/s"
  },
  { "enhet": "ecowitt-ha", "signal": "vader.regn", "omrakning": null },
  {
    "enhet": "ecowitt-ha",
    "signal": "vader.tryck",
    "omrakning": "inHg och mmHg räknas om till hPa"
  },
  { "enhet": "ecowitt-ha", "signal": "jord.fukt", "omrakning": "soilmoisture1–8 blir kanal1–8" },
  {
    "enhet": "ruuvitag",
    "signal": "kabin.temp",
    "omrakning": "Signalen följer rollen som ägaren väljer under Givare: kabin, motorrum, ute och de andra"
  },
  {
    "enhet": "ruuvitag",
    "signal": "kabin.fukt",
    "omrakning": "Signalen följer rollen som ägaren väljer under Givare: kabin, motorrum, ute och de andra"
  },
  { "enhet": "ruuvitag", "signal": "givare.batteri", "omrakning": null },
  {
    "enhet": "ruuvitag-pro",
    "signal": "kabin.temp",
    "omrakning": "Signalen följer rollen som ägaren väljer under Givare: kabin, motorrum, ute och de andra"
  },
  { "enhet": "ruuvitag-pro", "signal": "givare.batteri", "omrakning": null },
  {
    "enhet": "shelly-blu-ht",
    "signal": "kabin.temp",
    "omrakning": "Signalen följer rollen som ägaren väljer under Givare: kabin, motorrum, ute och de andra"
  },
  {
    "enhet": "shelly-blu-ht",
    "signal": "kabin.fukt",
    "omrakning": "Signalen följer rollen som ägaren väljer under Givare: kabin, motorrum, ute och de andra"
  },
  { "enhet": "shelly-blu-ht", "signal": "givare.batteri_procent", "omrakning": null },
  { "enhet": "shelly-ws90", "signal": "ute.temp", "omrakning": null },
  { "enhet": "shelly-ws90", "signal": "ute.fukt", "omrakning": null },
  { "enhet": "shelly-ws90", "signal": "vader.vind", "omrakning": null },
  { "enhet": "shelly-ws90", "signal": "vader.regn", "omrakning": null },
  {
    "enhet": "xiaomi-pvvx",
    "signal": "kabin.temp",
    "omrakning": "Signalen följer rollen som ägaren väljer under Givare: kabin, motorrum, ute och de andra"
  },
  {
    "enhet": "xiaomi-pvvx",
    "signal": "kabin.fukt",
    "omrakning": "Signalen följer rollen som ägaren väljer under Givare: kabin, motorrum, ute och de andra"
  },
  {
    "enhet": "bthome-givare",
    "signal": "kabin.temp",
    "omrakning": "Signalen följer rollen som ägaren väljer under Givare: kabin, motorrum, ute och de andra"
  },
  {
    "enhet": "inkbird-ibs-th2",
    "signal": "kabin.temp",
    "omrakning": "Signalen följer rollen som ägaren väljer under Givare: kabin, motorrum, ute och de andra"
  },
  { "enhet": "inkbird-ibs-th2", "signal": "givare.batteri_procent", "omrakning": null },
  { "enhet": "ecowitt-gw2000", "signal": "ute.temp", "omrakning": "°F räknas om till °C" },
  { "enhet": "ecowitt-gw2000", "signal": "ute.fukt", "omrakning": null },
  { "enhet": "ecowitt-gw2000", "signal": "vader.vind", "omrakning": "mph räknas om till m/s" },
  { "enhet": "ecowitt-gw2000", "signal": "vader.regn", "omrakning": "Tum räknas om till mm" },
  { "enhet": "ecowitt-gw2000", "signal": "vader.tryck", "omrakning": "inHg räknas om till hPa" },
  { "enhet": "ecowitt-gw1100", "signal": "ute.temp", "omrakning": "°F räknas om till °C" },
  { "enhet": "ecowitt-gw1100", "signal": "ute.fukt", "omrakning": null },
  { "enhet": "ecowitt-gw1200", "signal": "ute.temp", "omrakning": "°F räknas om till °C" },
  { "enhet": "ecowitt-gw1200", "signal": "ute.fukt", "omrakning": null },
  { "enhet": "ecowitt-wh51", "signal": "jord.fukt", "omrakning": "soilmoistureN blir kanalN" },
  { "enhet": "ecowitt-wh51", "signal": "givare.batteri", "omrakning": "soilbattN" },
  { "enhet": "nobo-hub", "signal": "hus.zon.temp", "omrakning": null },
  { "enhet": "nobo-hub", "signal": "hus.zon.lage", "omrakning": null },
  { "enhet": "nobo-hub", "signal": "nobo.kontakt", "omrakning": null },
  {
    "enhet": "whisper-power-8",
    "signal": "generator.gar",
    "omrakning": "Generatorn går enligt generatoringången på MasterBus"
  },
  {
    "enhet": "eberspacher-5dl",
    "signal": "forbrukare.gar",
    "omrakning": "Värmaren går enligt signalen som ägaren kopplar"
  },
  {
    "enhet": "victron-batteri-gx",
    "signal": "batteri.soc",
    "omrakning": "Tjänsten battery i GX-enheten: /Soc, /Dc/0/Voltage, /Dc/0/Current, /Dc/0/Power och /TimeToGo (sekunder): SoC i %, för batteriövervakarens bank (förbrukning eller navigation, under Inställningar → Victron)"
  },
  {
    "enhet": "victron-batteri-gx",
    "signal": "batteri.spanning",
    "omrakning": "Tjänsten battery i GX-enheten: /Soc, /Dc/0/Voltage, /Dc/0/Current, /Dc/0/Power och /TimeToGo (sekunder): spänningen i V"
  },
  {
    "enhet": "victron-batteri-gx",
    "signal": "batteri.strom",
    "omrakning": "Tjänsten battery i GX-enheten: /Soc, /Dc/0/Voltage, /Dc/0/Current, /Dc/0/Power och /TimeToGo (sekunder): strömmen i A, positiv vid laddning"
  },
  {
    "enhet": "victron-batteri-gx",
    "signal": "batteri.effekt",
    "omrakning": "Tjänsten battery i GX-enheten: /Soc, /Dc/0/Voltage, /Dc/0/Current, /Dc/0/Power och /TimeToGo (sekunder): effekten i W"
  },
  {
    "enhet": "victron-batteri-gx",
    "signal": "batteri.tid_kvar",
    "omrakning": "Tjänsten battery i GX-enheten: /Soc, /Dc/0/Voltage, /Dc/0/Current, /Dc/0/Power och /TimeToGo (sekunder): tiden kvar i timmar"
  },
  {
    "enhet": "victron-smartshunt-gx",
    "signal": "batteri.soc",
    "omrakning": "Som en batteriövervakare via GX: SoC i %, för batteriövervakarens bank (förbrukning eller navigation, under Inställningar → Victron)"
  },
  {
    "enhet": "victron-smartshunt-gx",
    "signal": "batteri.spanning",
    "omrakning": "Som en batteriövervakare via GX: spänningen i V"
  },
  {
    "enhet": "victron-smartshunt-gx",
    "signal": "batteri.strom",
    "omrakning": "Som en batteriövervakare via GX: strömmen i A, positiv vid laddning"
  },
  {
    "enhet": "victron-smartshunt-gx",
    "signal": "batteri.effekt",
    "omrakning": "Som en batteriövervakare via GX: effekten i W"
  },
  {
    "enhet": "victron-smartshunt-gx",
    "signal": "batteri.tid_kvar",
    "omrakning": "Som en batteriövervakare via GX: tiden kvar i timmar"
  },
  {
    "enhet": "victron-bmv712-gx",
    "signal": "batteri.soc",
    "omrakning": "Som en batteriövervakare via GX: SoC i %, för batteriövervakarens bank (förbrukning eller navigation, under Inställningar → Victron)"
  },
  {
    "enhet": "victron-bmv712-gx",
    "signal": "batteri.spanning",
    "omrakning": "Som en batteriövervakare via GX: spänningen i V"
  },
  {
    "enhet": "victron-bmv712-gx",
    "signal": "batteri.strom",
    "omrakning": "Som en batteriövervakare via GX: strömmen i A, positiv vid laddning"
  },
  {
    "enhet": "victron-bmv712-gx",
    "signal": "batteri.effekt",
    "omrakning": "Som en batteriövervakare via GX: effekten i W"
  },
  {
    "enhet": "victron-bmv712-gx",
    "signal": "batteri.tid_kvar",
    "omrakning": "Som en batteriövervakare via GX: tiden kvar i timmar"
  },
  {
    "enhet": "victron-lynx-bms-gx",
    "signal": "batteri.soc",
    "omrakning": "Som en batteriövervakare via GX: SoC i %, för batteriövervakarens bank (förbrukning eller navigation, under Inställningar → Victron)"
  },
  {
    "enhet": "victron-lynx-bms-gx",
    "signal": "batteri.spanning",
    "omrakning": "Som en batteriövervakare via GX: spänningen i V"
  },
  {
    "enhet": "victron-lynx-bms-gx",
    "signal": "batteri.strom",
    "omrakning": "Som en batteriövervakare via GX: strömmen i A, positiv vid laddning"
  },
  {
    "enhet": "victron-lynx-bms-gx",
    "signal": "batteri.effekt",
    "omrakning": "Som en batteriövervakare via GX: effekten i W"
  },
  {
    "enhet": "victron-lynx-bms-gx",
    "signal": "batteri.tid_kvar",
    "omrakning": "Som en batteriövervakare via GX: tiden kvar i timmar"
  },
  {
    "enhet": "victron-gx",
    "signal": "victron.kontakt",
    "omrakning": "Navet får meddelanden från GX-enheten via MQTT"
  },
  {
    "enhet": "victron-gx",
    "signal": "landstrom.finns",
    "omrakning": "system/0/Ac/ActiveIn/Source: 1 (nätet) eller 3 (landström) är landström"
  },
  {
    "enhet": "victron-gx",
    "signal": "ac.kalla",
    "omrakning": "system/0/Ac/ActiveIn/Source: landström, generator (2), eller växelriktaren när VE.Bus växelriktar"
  },
  {
    "enhet": "victron-gx",
    "signal": "sol.effekt",
    "omrakning": "system/0/Dc/Pv/Power, alla solladdare"
  },
  {
    "enhet": "victron-cerbo-gx",
    "signal": "victron.kontakt",
    "omrakning": "Som en GX-enhet"
  },
  {
    "enhet": "victron-cerbo-gx",
    "signal": "landstrom.finns",
    "omrakning": "Som en GX-enhet"
  },
  {
    "enhet": "victron-cerbo-gx",
    "signal": "ac.kalla",
    "omrakning": "Som en GX-enhet"
  },
  {
    "enhet": "victron-cerbo-gx",
    "signal": "sol.effekt",
    "omrakning": "Som en GX-enhet"
  },
  {
    "enhet": "victron-mppt-gx",
    "signal": "sol.skord",
    "omrakning": "Tjänsten solarcharger: /History/Daily/0/Yield i kWh, summan för alla solladdare"
  },
  {
    "enhet": "victron-mppt-gx",
    "signal": "sol.lage",
    "omrakning": "Tjänsten solarcharger: /State som Kolls laddlägen"
  },
  {
    "enhet": "victron-multiplus-gx",
    "signal": "landstrom.spanning",
    "omrakning": "Tjänsten vebus: /Ac/ActiveIn/L1/V när landströmmen är ansluten"
  },
  {
    "enhet": "victron-multiplus-gx",
    "signal": "landstrom.strom",
    "omrakning": "Tjänsten vebus: /Ac/ActiveIn/L1/I"
  },
  {
    "enhet": "victron-multiplus-gx",
    "signal": "landstrom.effekt",
    "omrakning": "Tjänsten vebus: /Ac/ActiveIn/P"
  },
  {
    "enhet": "victron-multiplus-gx",
    "signal": "ac.effekt",
    "omrakning": "Tjänsten vebus: /Ac/Out/P som ut1"
  },
  {
    "enhet": "victron-multiplus-gx",
    "signal": "vaxelriktare.pa",
    "omrakning": "Tjänsten vebus: /Mode 2 (bara växelriktare) eller 3 (på)"
  },
  {
    "enhet": "victron-multiplus-gx",
    "signal": "laddare.lage",
    "omrakning": "Tjänsten vebus: /State som Kolls laddlägen, instansen vebus"
  },
  {
    "enhet": "victron-multiplus-gx",
    "signal": "laddare.strom",
    "omrakning": "Tjänsten vebus: /Dc/0/Current när den laddar, instansen vebus"
  },
  {
    "enhet": "victron-orion-gx",
    "signal": "laddare.lage",
    "omrakning": "Tjänsten dcdc: /State, instansen dcdc"
  },
  {
    "enhet": "victron-tank-gx",
    "signal": "tank.niva",
    "omrakning": "Tjänsten tank: /Level i %, och tankens namn ur /FluidType som på NMEA 2000 (diesel, farskvatten, gravatten, svartvatten, bensin)"
  },
  {
    "enhet": "victron-tank-gx",
    "signal": "tank.kapacitet",
    "omrakning": "Tjänsten tank: /Capacity i m³ blir liter"
  },
  {
    "enhet": "victron-tank-gx",
    "signal": "tank.volym",
    "omrakning": "Tjänsten tank: /Remaining i m³ blir liter"
  },
  {
    "enhet": "victron-temp-gx",
    "signal": "kyl.temp",
    "omrakning": "Tjänsten temperature: /TemperatureType 1 (kylskåp)"
  },
  {
    "enhet": "victron-temp-gx",
    "signal": "frys.temp",
    "omrakning": "Tjänsten temperature: /TemperatureType 6 (frys)"
  },
  {
    "enhet": "victron-temp-gx",
    "signal": "kabin.temp",
    "omrakning": "Tjänsten temperature: /TemperatureType 3 (rum), på en båt"
  },
  {
    "enhet": "victron-temp-gx",
    "signal": "hus.inne.temp",
    "omrakning": "Tjänsten temperature: /TemperatureType 3 (rum), i ett hus"
  },
  {
    "enhet": "victron-temp-gx",
    "signal": "ute.temp",
    "omrakning": "Tjänsten temperature: /TemperatureType 4 (ute)"
  },
  {
    "enhet": "victron-temp-gx",
    "signal": "batteri.temp",
    "omrakning": "Tjänsten temperature: /TemperatureType 0 (batteri), för förbrukningsbanken"
  },
  {
    "enhet": "victron-smartshunt",
    "signal": "batteri.soc",
    "omrakning": "Instant Readout, batteriövervakaren (post 0x02): SoC i 0,1 %, spänningen i 0,01 V, strömmen i mA och TTG i minuter: SoC i %, för batteriövervakarens bank (förbrukning eller navigation, under Inställningar → Victron)"
  },
  {
    "enhet": "victron-smartshunt",
    "signal": "batteri.spanning",
    "omrakning": "Instant Readout, batteriövervakaren (post 0x02): SoC i 0,1 %, spänningen i 0,01 V, strömmen i mA och TTG i minuter: spänningen i V"
  },
  {
    "enhet": "victron-smartshunt",
    "signal": "batteri.strom",
    "omrakning": "Instant Readout, batteriövervakaren (post 0x02): SoC i 0,1 %, spänningen i 0,01 V, strömmen i mA och TTG i minuter: strömmen i A, positiv vid laddning"
  },
  {
    "enhet": "victron-smartshunt",
    "signal": "batteri.effekt",
    "omrakning": "Instant Readout, batteriövervakaren (post 0x02): SoC i 0,1 %, spänningen i 0,01 V, strömmen i mA och TTG i minuter: effekten i W"
  },
  {
    "enhet": "victron-smartshunt",
    "signal": "batteri.tid_kvar",
    "omrakning": "Instant Readout, batteriövervakaren (post 0x02): SoC i 0,1 %, spänningen i 0,01 V, strömmen i mA och TTG i minuter: tiden kvar i timmar"
  },
  {
    "enhet": "victron-smartshunt",
    "signal": "batteri.temp",
    "omrakning": "Hjälpingången som temperatur (0,01 K) blir °C"
  },
  {
    "enhet": "victron-bmv712",
    "signal": "batteri.soc",
    "omrakning": "Som SmartShunt: SoC i %, för batteriövervakarens bank (förbrukning eller navigation, under Inställningar → Victron)"
  },
  {
    "enhet": "victron-bmv712",
    "signal": "batteri.spanning",
    "omrakning": "Som SmartShunt: spänningen i V"
  },
  {
    "enhet": "victron-bmv712",
    "signal": "batteri.strom",
    "omrakning": "Som SmartShunt: strömmen i A, positiv vid laddning"
  },
  {
    "enhet": "victron-bmv712",
    "signal": "batteri.effekt",
    "omrakning": "Som SmartShunt: effekten i W"
  },
  {
    "enhet": "victron-bmv712",
    "signal": "batteri.tid_kvar",
    "omrakning": "Som SmartShunt: tiden kvar i timmar"
  },
  {
    "enhet": "victron-bmv712",
    "signal": "batteri.temp",
    "omrakning": "Som SmartShunt"
  },
  {
    "enhet": "victron-lynx-bms",
    "signal": "batteri.soc",
    "omrakning": "Instant Readout, BMS (post 0x0A): SoC i %, för batteriövervakarens bank (förbrukning eller navigation, under Inställningar → Victron)"
  },
  {
    "enhet": "victron-lynx-bms",
    "signal": "batteri.spanning",
    "omrakning": "Instant Readout, BMS (post 0x0A): spänningen i V"
  },
  {
    "enhet": "victron-lynx-bms",
    "signal": "batteri.strom",
    "omrakning": "Instant Readout, BMS (post 0x0A): strömmen i A, positiv vid laddning"
  },
  {
    "enhet": "victron-lynx-bms",
    "signal": "batteri.effekt",
    "omrakning": "Instant Readout, BMS (post 0x0A): effekten i W"
  },
  {
    "enhet": "victron-lynx-bms",
    "signal": "batteri.tid_kvar",
    "omrakning": "Instant Readout, BMS (post 0x0A): tiden kvar i timmar"
  },
  {
    "enhet": "victron-lynx-bms",
    "signal": "batteri.temp",
    "omrakning": "Instant Readout, BMS: temperaturen minus 40"
  },
  {
    "enhet": "victron-smartlithium",
    "signal": "batteri.spanning",
    "omrakning": "Instant Readout, Smart Lithium (post 0x05): spänningen i 0,01 V"
  },
  {
    "enhet": "victron-smartlithium",
    "signal": "batteri.temp",
    "omrakning": "Instant Readout, Smart Lithium: temperaturen minus 40"
  },
  {
    "enhet": "victron-mppt",
    "signal": "sol.effekt",
    "omrakning": "Instant Readout, solladdaren (post 0x01): PV-effekten i W, summan för alla solladdare"
  },
  {
    "enhet": "victron-mppt",
    "signal": "sol.skord",
    "omrakning": "Instant Readout, solladdaren: skörden i dag i 0,01 kWh, summan"
  },
  {
    "enhet": "victron-mppt",
    "signal": "sol.lage",
    "omrakning": "Instant Readout, solladdaren: enhetens läge som Kolls laddlägen"
  },
  {
    "enhet": "victron-orion",
    "signal": "laddare.lage",
    "omrakning": "Instant Readout, DC/DC (post 0x04): enhetens läge, instansen dcdc"
  },
  {
    "enhet": "victron-phoenix",
    "signal": "vaxelriktare.pa",
    "omrakning": "Instant Readout, växelriktaren (post 0x03): på när läget inte är av"
  },
  {
    "enhet": "victron-phoenix",
    "signal": "ac.effekt",
    "omrakning": "Instant Readout, växelriktaren: skenbar effekt i VA som ut1"
  },
  {
    "enhet": "victron-bluesmart",
    "signal": "laddare.lage",
    "omrakning": "Instant Readout, AC-laddaren (post 0x08): enhetens läge, instansen smartladdare"
  },
  {
    "enhet": "victron-bluesmart",
    "signal": "laddare.strom",
    "omrakning": "Instant Readout, AC-laddaren: strömmen på utgång 1 i 0,1 A"
  },
  {
    "enhet": "varmare-utblas",
    "signal": "forbrukare.utblas",
    "omrakning": "Givarens temperatur, eller entiteten i Home Assistant"
  },
  {
    "enhet": "varmare-utblas",
    "signal": "forbrukare.gar",
    "omrakning": "Härledd i navet: på när utblåset har varit minst 15 °C varmare än jämförelsen i 2 minuter, av när skillnaden har varit under 8 °C i 5 minuter (gränserna ändras i appen)"
  }
]
